// imageUtils.js

const downloadImages = (selectedPhotos, allPhotos) => {
  if (selectedPhotos.length === 0) {
    return;
  }
  console.log(selectedPhotos);
  const downloadImage = (photoId, fileName) => {
    const imageSrc = allPhotos.find((p) => p.id === photoId)?.url.url;

    if (imageSrc) {
      const link = document.createElement("a");
      link.href = imageSrc;
      link.download = fileName || `image-${photoId}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error(`Image for photo ID ${photoId} not found.`);
    }
  };

  selectedPhotos.forEach((photoId) => {
    const photo = allPhotos.find((p) => p.id === photoId);
    if (photo) {
      downloadImage(photoId, `photo-${photoId}.png`);
    }
  });
};

export default downloadImages;
